// Label sebuah modul di layar admin dan peserta.
//
// Kolom `code` pada modul punya tiga keadaan yang BERBEDA, dan ketiganya harus
// tetap terpisah (membandingkannya dengan `!code` menyatukan dua yang pertama):
//   null / undefined -> otomatis "M{urutan}"   (perilaku sebelum label bisa diubah)
//   ""               -> tanpa label            (admin sengaja menyembunyikannya)
//   teks lain        -> label kustom, mis. "BAB 1"
// Urutan dihitung dari posisi modul pada daftar, bukan disimpan, jadi label
// otomatis ikut bergeser saat modul diurutkan ulang sedangkan label kustom ikut modulnya.

/** Label ringkas ("M1", "BAB 1"), atau "" bila disembunyikan. */
export function modLabel(mod, index) {
  const code = mod?.code
  return code == null ? `M${index + 1}` : code
}

/**
 * Label untuk judul bagian ("Modul 1" / "BAB 1"), atau "" bila disembunyikan.
 * Yang otomatis dieja penuh; yang kustom dipakai apa adanya.
 */
export function modHeading(mod, index, lang) {
  const code = mod?.code
  return code == null ? `${lang === "id" ? "Modul" : "Module"} ${index + 1}` : code
}

/** Gabungkan label dan judul dengan pemisah, tanpa pemisah yatim bila label kosong. */
export const withLabel = (label, title, sep = " · ") => [label, title].filter(Boolean).join(sep)
